import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

export const HelpLink: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <p className="jg-space-mtsm jg-space-mbn">
      {t('donateButton.ownButton.needHelp')}{' '}
      <a
        className="jg-text-link"
        href="https://justgiving-charity-support.zendesk.com/hc/en-us/articles/10026237039261"
        rel="noopener noreferrer"
        target="_blank"
      >
        {t('donateButton.ownButton.howToAddPopupCheckout')}
      </a>
    </p>
  );
};
